module.exports = __webpack_public_path__ + "49bdd901dcf626b3551c560ebe58e86c.svg";